import { createFileRoute, Outlet } from "@tanstack/react-router";
import { guardConsole } from "@/lib/route-guard";

export const Route = createFileRoute("/_authenticated/partner")({
  beforeLoad: guardConsole("partner"),
  component: () => <Outlet />,
});
